import { Address } from 'models/Address/address.model';
import { serializable, alias, object, primitive } from 'serializr';

export class ProductDistributionRoute {
  @serializable
  id?: number;

  @serializable(alias('end_market_location', primitive()))
  endMarketLocation?: string;

  @serializable
  units?: number;

  @serializable(object(Address))
  address?: Address;

  @serializable(alias('transportation_air', primitive()))
  transportationAir?: boolean;

  @serializable
  createdAt?: string;

  @serializable
  updatedAt?: string;
}
